import { render } from "./NotFound.vue?vue&type=template&id=65b6097e"
const script = {}
script.render = render

export default script